import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Card from '../../components/Card'
import Header from '../../components/Header'
import Image from '../../components/Image'
import MedicationDisplay from '../../components/MedicationDisplay'
import OpticNerveProgression from '../../components/OpticNerveProgression'
import Paginate from '../../components/Paginate'
import Paragraph from '../../components/Paragraph'
import PatientImages from '../../components/PatientImages'
import SectionHeader from '../../components/SectionHeader'
import SummaryBullet from '../../components/SummaryBullet'
import Text from '../../components/Text'
import Video from '../../components/Video'
import VisualFieldProgression from '../../components/VisualFieldProgression'
import patient from '../../stores/patient'

@observer
export default class LearnSession123 extends Component {
  render() {
    return (
      <Fragment>
        {/* YOUR GLAUCOMA */}
        <SectionHeader color="blue" icon="far fa-dot-circle" str="titles.yourGlaucoma" />
        <Video />
        {/* EXAM RESULTS */}
        <SectionHeader color="blue" icon="fas fa-eye" str="titles.examResults" />
        {/* EXAM RESULTS - THE OPTIC NERVE */}
        <Header str="titles.theOpticNerve" />
        <Card>
          <Card.Pad>
            <Image src="/images/donuts.png" />
            <Paragraph str="prose.donuts" />
          </Card.Pad>
        </Card>
        <OpticNerveProgression />
        {patient.hasOpticNerves &&
          <Fragment>
            {/* EXAM RESULTS - YOUR OPTIC NERVES */}
            <Header str="titles.yourOpticNerves" />
            <PatientImages
              left={patient.fields.leftOpticNerve}
              leftDate={patient.fields.leftOpticNerveDate}
              right={patient.fields.rightOpticNerve}
              rightDate={patient.fields.rightOpticNerveDate}
            />
          </Fragment>
        }
        {/* EXAM RESULTS - THE VISUAL FIELD TEST */}
        <Header str="titles.theVisualFieldTest" />
        <Card>
          <Card.Pad>
            <Paragraph str="prose.visualFieldTestCreates" />
            <Paragraph str="prose.testIsImportant" />
            <Paragraph str="prose.yourDoctorCanCompare" />
            <Paragraph str="prose.asGlaucomaGetsWorse" />
          </Card.Pad>
        </Card>
        {patient.hasVFIs &&
          <Fragment>
            {/* EXAM RESULTS - YOUR TEST RESULTS */}
            <Header str="titles.yourTestResults" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.100PercentVeryBest" />
                {patient.mostRecentLeftVFI && <Paragraph str="prose.yourVisionInLeftEye" inserts={{ vfi: patient.mostRecentLeftVFI }} />}
                {patient.mostRecentRightVFI && <Paragraph str="prose.yourVisionInRightEye" inserts={{ vfi: patient.mostRecentRightVFI }} />}
                <Paragraph str="prose.byTakingYourMedications" />
              </Card.Pad>
            </Card>
          </Fragment>
        }
        {patient.hasVisualFields &&
          <Fragment>
            {/* EXAM RESULTS - NORMAL VISUAL FIELD */}
            <Header str="titles.normalVisualField" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.lookAtVisualFieldTests" />
              </Card.Pad>
              <Card.Divider />
              <Card.Pad>
                <Image src="/images/normal-visual-field.png" />
              </Card.Pad>
            </Card>
            {patient.hasRecentVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR RECENT VISUAL FIELDS */}
                <Header str="titles.yourRecentVisualFields" />
                <PatientImages
                  left={patient.fields.leftRecentField}
                  right={patient.fields.rightRecentField}
                  leftVFI={patient.fields.leftRecentVFI}
                  rightVFI={patient.fields.rightRecentVFI}
                  leftDate={patient.fields.leftRecentFieldDate}
                  rightDate={patient.fields.rightRecentFieldDate}
                />
              </Fragment>
            }
            {patient.hasPreviousVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR PREVIOUS VISUAL FIELDS */}
                <Header str="titles.yourPreviousVisualFields" />
                <PatientImages
                  left={patient.fields.leftPreviousField}
                  right={patient.fields.rightPreviousField}
                  leftVFI={patient.fields.leftPreviousVFI}
                  rightVFI={patient.fields.rightPreviousVFI}
                  leftDate={patient.fields.leftPreviousFieldDate}
                  rightDate={patient.fields.rightPreviousFieldDate}
                  headerStr="titles.yourPreviousVisualFields"
                />
              </Fragment>
            }
            {patient.hasBaselineVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR BASELINE VISUAL FIELDS */}
                <Header str="titles.yourBaselineVisualFields" />
                <PatientImages
                  left={patient.fields.leftBaselineField}
                  right={patient.fields.rightBaselineField}
                  leftVFI={patient.fields.leftBaselineVFI}
                  rightVFI={patient.fields.rightBaselineVFI}
                  leftDate={patient.fields.leftBaselineFieldDate}
                  rightDate={patient.fields.rightBaselineFieldDate}
                  headerStr="titles.yourBaselineVisualFields"
                />
              </Fragment>
            }
          </Fragment>
        }
        {/* VISUAL FIELD PROGRESSION */}
        <SectionHeader color="blue" icon="fas fa-hourglass-half" str="titles.visualFieldProgression" />
        <Card>
          <Card.Pad>
            <Paragraph str="prose.howGlaucomaAffectsYourVision" />
            <Paragraph str="prose.glaucomaIsSerious" />
          </Card.Pad>
        </Card>
        <VisualFieldProgression />
        {/* TREATMENT PLAN */}
        <SectionHeader color="blue" icon="fas fa-search-plus" str="titles.treatmentPlan" />
        <Card>
          <Card.Pad>
            <Paragraph str="prose.onlyKnownTreatment" />
          </Card.Pad>
        </Card>
        {patient.hasMedications &&
          <Fragment>
            {/* TREATMENT PLAN - MEDICATIONS */}
            <Header str="titles.medications" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.doctorHasRecommended" inserts={{ doctor: patient.fields.doctor }} />
              </Card.Pad>
            </Card>
            {patient.fields.medications.map((m, i) => (
              <Card key={i}>
                <Card.Pad>
                  <MedicationDisplay medication={m} />
                </Card.Pad>
                <Card.Divider />
                <Card.Pad>
                  <Paragraph str={`choices.medicationDescription.${m.prescription}`} />
                </Card.Pad>
              </Card>
            ))}
            <Card>
              <Card.Pad>
                <Paragraph str="prose.glaucomaMedicationTip" />
              </Card.Pad>
            </Card>
          </Fragment>
        }
        {patient.hasSurgeries &&
          <Fragment>
            {/* TREATMENT PLAN - SURGERIES */}
            <Header str="titles.surgeries" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.toHelpControlYourGlaucoma" />
              </Card.Pad>
            </Card>
            {patient.fields.surgeries.map((s, i) => (
              <Card key={i}>
                <Card.Title str={`choices.surgery.${s}`} />
                <Card.Pad>
                  <Paragraph str={`choices.surgeryDescription.${s}`} />
                </Card.Pad>
              </Card>
            ))}
          </Fragment>
        }
        {/* SUMMARY */}
        <SectionHeader color="blue" icon="fas fa-file-alt" str="titles.summary" />
        <SummaryBullet color="blue" icon="far fa-dot-circle">
          <Text str="prose.youHaveBeenDiagnosedWith" />&nbsp;&nbsp;
          <Text str={`choices.diagnosis.${patient.fields.diagnosis}`} />
        </SummaryBullet>
        {patient.hasVFIs &&
          <SummaryBullet color="blue" icon="fas fa-eye">
            {patient.mostRecentLeftVFI && <Text str="prose.yourVisionInLeftEye" inserts={{ vfi: patient.mostRecentLeftVFI }} />}
            {patient.mostRecentLeftVFI && patient.mostRecentRightVFI && <br />}
            {patient.mostRecentRightVFI && <Text str="prose.yourVisionInRightEye" inserts={{ vfi: patient.mostRecentRightVFI }} />}
          </SummaryBullet>
        }
        <SummaryBullet color="blue" icon="fas fa-hourglass-half" str="prose.graduallyBlindspotsDevelop" />
        {patient.hasMedications &&
          <SummaryBullet color="blue" icon="fas fa-search-plus">
            <Text str="prose.youHaveBeenPrescribed" />&nbsp;&nbsp;
            {patient.fields.medications.map((m, i) => (
              <Fragment key={i}>
                <Text str={`choices.medication.${m.prescription}`} />
                {i !== patient.fields.medications.length - 1 && ', '}
              </Fragment>
            ))}
          </SummaryBullet>
        }
        <SummaryBullet color="blue" icon="fas fa-question" str="prose.questionsForYourDoctor" />
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button next
            color="orange"
            str="titles.use"
            to={`/patient-session/use`}
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PatientSession/LearnPage.js